
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';
import { Settlement, PaymentInfo } from '@/types/expense';

interface SettlementCardProps {
  settlements: Settlement[];
  formatCurrency: (amount: number) => string;
  paymentInfos: Record<string, PaymentInfo>;
}

const SettlementCard: React.FC<SettlementCardProps> = ({ 
  settlements, 
  formatCurrency, 
  paymentInfos 
}) => {
  const getPaymentMethodDisplay = (userId: string) => {
    const info = paymentInfos[userId];
    if (!info) return null;
    
    const methodLabels = {
      venmo: 'Venmo',
      zelle: 'Zelle',
      cashapp: 'Cash App',
      other: 'Other'
    };
    
    return (
      <div className="text-xs text-gray-500 mt-1">
        {methodLabels[info.method]}: {info.handle}
      </div>
    );
  };

  return (
    <Card className="border-t-4 border-t-glowingTeal">
      <CardHeader>
        <CardTitle className="text-xl text-navteal">Settlement Plan</CardTitle>
      </CardHeader>
      <CardContent>
        {settlements.length === 0 ? (
          <div className="text-center text-gray-500">Everyone is settled up!</div>
        ) : (
          <ul className="space-y-3">
            {settlements.map((settlement, index) => (
              <li 
                key={index}
                className="p-3 rounded-md border"
              >
                <div className="flex justify-between items-center">
                  <span className="font-medium">{settlement.fromName}</span>
                  <span className="text-green-600 font-medium">
                    {formatCurrency(settlement.amount)}
                  </span>
                </div>
                <div className="text-sm text-gray-500">
                  pays {settlement.toName}
                  {getPaymentMethodDisplay(settlement.to)}
                </div>
              </li>
            ))}
          </ul>
        )}
        <div className="mt-4 text-sm text-gray-500 flex items-center">
          <AlertCircle className="h-4 w-4 mr-1" />
          <span>Add your payment details above to make settling up easier.</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default SettlementCard;
